import { Strategy } from '../resolvers/StrategyResolver';
import { RegistrationBuilderBase } from './RegistrationBuilderBase';
class RegistrationFactoryResolver {
    constructor(factory, strategy = Strategy.Instance) {
        this.factory = factory;
        this.strategy = strategy;
    }
    get(container, key) {
        if (this.strategy === Strategy.Singleton || this.strategy === Strategy.Scoped) {
            if (!this.instance) {
                this.instance = this.factory(container, key);
            }
            return this.instance;
        }
        return this.factory(container, key);
    }
    clone() {
        return new RegistrationFactoryResolver(this.factory, this.strategy);
    }
}
export class FactoryRegistrationBuilder extends RegistrationBuilderBase {
    constructor(container, factory) {
        super(container, new RegistrationFactoryResolver(factory));
        this.instancePerDependency();
    }
    singleInstance() {
        this.resolver.strategy = Strategy.Singleton;
        return this;
    }
    instancePerScope() {
        this.resolver.strategy = Strategy.Scoped;
        return this;
    }
    instancePerDependency() {
        this.resolver.strategy = Strategy.Transient;
        return this;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmFjdG9yeVJlZ2lzdHJhdGlvbkJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJGYWN0b3J5UmVnaXN0cmF0aW9uQnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFFekQsT0FBTyxFQUFFLHVCQUF1QixFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFFcEUsTUFBTSwyQkFBMkI7SUFFN0IsWUFBb0MsT0FBeUIsRUFBUyxXQUFXLFFBQVEsQ0FBQyxRQUFRO1FBQTlELFlBQU8sR0FBUCxPQUFPLENBQWtCO1FBQVMsYUFBUSxHQUFSLFFBQVEsQ0FBb0I7SUFBRyxDQUFDO0lBRS9GLEdBQUcsQ0FBQyxTQUFvQixFQUFFLEdBQVc7UUFDeEMsSUFBSSxJQUFJLENBQUMsUUFBUSxLQUFLLFFBQVEsQ0FBQyxTQUFTLElBQUksSUFBSSxDQUFDLFFBQVEsS0FBSyxRQUFRLENBQUMsTUFBTSxFQUFFO1lBQzNFLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFO2dCQUNoQixJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsU0FBUyxFQUFFLEdBQUcsQ0FBQyxDQUFDO2FBQ2hEO1lBRUQsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDO1NBQ3hCO1FBRUQsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLFNBQVMsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUN4QyxDQUFDO0lBRU0sS0FBSztRQUNSLE9BQU8sSUFBSSwyQkFBMkIsQ0FBSSxJQUFJLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUMzRSxDQUFDO0NBQ0o7QUFFRCxNQUFNLE9BQU8sMEJBQThCLFNBQVEsdUJBQTBCO0lBQ3pFLFlBQW1CLFNBQW9CLEVBQUUsT0FBeUI7UUFDOUQsS0FBSyxDQUFDLFNBQVMsRUFBRSxJQUFJLDJCQUEyQixDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7UUFDM0QsSUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUM7SUFDakMsQ0FBQztJQUVNLGNBQWM7UUFDakIsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQztRQUU1QyxPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0lBRU0sZ0JBQWdCO1FBQ25CLElBQUksQ0FBQyxRQUFRLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQyxNQUFNLENBQUM7UUFFekMsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUVNLHFCQUFxQjtRQUN4QixJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUMsU0FBUyxDQUFDO1FBRTVDLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7Q0FDSiJ9